export default __webpack_public_path__ + "static/media/yellow_2.png";